<app-modal-view #modal="modal"
                [modalTitle]="activeTitle"
                [showFooter]="true"
                data-testid="warranty-modal">

  <section modal-body>

    <!-- CREDIT -->
    <article *ngIf="isActiveSequence('creditTier')"
             class="d-flex flex-column align-items-center"
             data-testid="warranty-step-creditTier">
      <div class="w-100 my-3"
           style="max-width: 600px">
        <app-credit-tier-input></app-credit-tier-input>
      </div>
      <ul class="mb-0">
        <li>Payments quoted are based on the credit tier you selected.</li>
        <li>Payments may vary based on your credit profile and other factors.</li>
      </ul>
    </article>

    <!-- WARRANTY COVERAGE -->
    <!-- Hide Component to Preserve Active View Index -->
    <article [ngClass]="{ 'd-none': !isActiveSequence('warrantyUi') }"
             data-testid="warranty-step-warrantyUi">
      <app-warranty></app-warranty>
    </article>

    <!-- CLEAR CARE PRODUCT -->
    <article *ngIf="isActiveSequence('clearGraph')"
             class="w-100 mx-auto"
             style="max-width: 800px"
             data-testid="warranty-step-clearGraph">
      <app-clear-graph [condition]="uiState.warrantyUi.vehicleCondition"></app-clear-graph>
    </article>


    <!-- GAP PRODUCT -->
    <article *ngIf="isActiveSequence('gapGraph')"
             class="w-100 mx-auto"
             style="max-width: 700px"
             data-testid="warranty-step-gapGraph">
      <app-gap-graph></app-gap-graph>
    </article>

  </section>

  <section modal-footer>

    <article class="d-flex align-items-center justify-content-between">
      <button *ngIf="!allowWarrantyUiNavBack"
              class="btn app-btn-neutral"
              type="button"
              (click)="previousSequence()"
              data-testid="warranty-nav-back">
        BACK
      </button>

      <app-warranty-nav-button *ngIf="allowWarrantyUiNavBack"
                               navDirection="reverse">
      </app-warranty-nav-button>

      <mat-stepper *ngIf="presentationBreadCrumbsFlag" headerPosition="bottom" #stepper (selectionChange)="goToSequence($event)">
        <mat-step
          *ngFor="let step of uiState.modalSequence" 
          [label]="step.label"
          [state]="step.state"
        >
        </mat-step>

        <ng-template matStepperIcon="credit">
          <mat-icon>credit_score</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="clear">
          <mat-icon>health_and_safety</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="warranty">
          <mat-icon>verified_user</mat-icon>
        </ng-template>
        <ng-template matStepperIcon="gap">
          <mat-icon>area_chart</mat-icon>
        </ng-template>
      </mat-stepper>

      <button *ngIf="!allowWarrantyUiNavNext"
              class="btn app-btn-secondary"
              type="button"
              (click)="nextSequence()"
              data-testid="warranty-nav-next">
        NEXT
      </button>

      <app-warranty-nav-button *ngIf="allowWarrantyUiNavNext"
                               navDirection="forward">
      </app-warranty-nav-button>
    </article>

  </section>

</app-modal-view>